// extracted by mini-css-extract-plugin
export default {"container":"_3MhQ0","wrapper":"_2xRjX","listItemMobile":"_1mCjK","pagination":"_3sicg","separator":"PJZ1s"};